'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureStore = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _jalan = require('jalan');

var _index = require('../reducers/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('../sagas/index');

var _index4 = _interopRequireDefault(_index3);

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _meta = require('./meta');

var _ga = require('./ga');

var _routing = require('../constants/routing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* injects from baggage-loader */

function configureStore(history) {

  history.listen(function (ev) {
    if (ev.action !== 'PUSH') return;
    (0, _ga.pageView)(ev.pathname);
  });

  var jalanSaga = (0, _jalan.createJalan)(history, [{ '/': _routing.JALAN_INDEX }, { '/user/{userId}': _routing.JALAN_USER_LIST }, { '/index-project/{userId}/{projectId}': _routing.JALAN_INDEX_PROJECT }, { '/project/{projectId}': _routing.JALAN_PROJECT }, { '/project-node/{projectId}/{nodeId}': _routing.JALAN_PROJECT_NODE }, { '/node/{projectId}/{nodeId}': _routing.JALAN_NODE },

  /*
    { '/user-list-project/{userId}/{projectId}': JALAN_USER_LIST_PROJECT },
    { '/user-project/{userId}/{projectId}': JALAN_USER_PROJECT },
    { '/user-project-node/{userId}/{projectId}/{nodeId}': JALAN_USER_PROJECT_NODE },
    { '/user-node/{userId}/{projectId}/{nodeId}': JALAN_USER_NODE },
  */

  { '/test': _routing.JALAN_TEST }]);

  var middlewares = [_meta.meta, (0, _reduxSaga2.default)(jalanSaga, _index4.default), _reduxThunk2.default];

  try {
    var debugConfig = localStorage.getItem('debug');
    if (/.*logger.*/.test(debugConfig)) {
      middlewares.push(_logger2.default);
    }
  } catch (err) {
    // pass
  }

  var store = _redux.applyMiddleware.apply(undefined, middlewares)(_redux.createStore)(_index2.default);

  return store;
}
// import { error } from './rollbar';

// error('Hello World!', { actions: { type: 'POST', payload: { postId: 123 } } });


//////////////////
// WEBPACK FOOTER
// ./app/store/index.js
// module id = 639
// module chunks = 1